export default {
  //导航栏
  barmessage: {
    Home:'บ้าน',
    data:'การค้นคืนข้อมูล',
    About:'เกี่ยวกับเรา',
    productService:'บริการผลิตภัณฑ์',
    cases:'คดี',
    news:'ข่าว',
    contactUs:'ติดต่อเรา',
    login:'ท่าเรือ',
    report:'สถิติข้อมูล',
    LOGOtitle:'ບໍ່ລິການ ຂໍ້ມູນ'
  },

  queryboardmessage: { //查询面板
    polygon:'รูปหลายเหลี่ยม',
    nominatim:'ป้อนชื่อสถานที่',
    producttype:'เกรดผลิตภัณฑ์',
    cloud:'มีเมฆปกคลุม <',
    sensing:'วันที่ถ่ายภาพ',
    satellite:'เซ็นเซอร์ดาวเทียม',
    drawpolygon:'วาดรูปหลายเหลี่ยม',
    drawrectangle:'วาดสี่เหลี่ยมผืนผ้า',
    clear:'ล้างสภาพโซน',
    query:'การค้นคืนข้อมูล',
    cart:'แสดง/ซ่อนรถเข็น',
    togglebutton:'สลับแผงคิวรี',
    uploadfailed:'รูปแบบข้อมูลที่ไม่รองรับ',
    uploadsuccessed:'อัปโหลดข้อมูลเวกเตอร์เรียบร้อยแล้ว',
    uploadbutton:'อัปโหลดไฟล์',
    uploadtitle:'อัปโหลดเวกเตอร์',
    upoladtip:'รองรับไฟล์ SHP (.zip ไฟล์รวมถึง .dbf, .shp, .prj ไฟล์สามประเภทชื่อไฟล์ต้องเป็นภาษาอังกฤษ)',
  },

  querymapmessage: { //查询底图上的文字
    lonlat:'ละติจูดลองจิจูด',
    fullscreen:'สลับโหมดเต็มหน้าจอ',
    owslayername:'แผนที่ฐาน OSM',
    satellitelayername:'แผนที่ฐานภาพการรับรู้ระยะไกล',
  },

  resultlistmessage: { //查询结果面板,部分与购物车面板共用
    satellite:'ดาวเทียม',
    sensingdate:'วันที่ถ่ายภาพ',
    online:'ออนไลน์',
    offline:'ออฟไลน์',
    display: 'Display {startindex} to {endindex} of {count} products',
    cartdisplay: 'Your Cart Contains { itemcount } products.',
    nofound:'ไม่พบสินค้า',
    viewdata:'ดูรายละเอียดข้อมูล',
    zoomtodata:'ค้นหาข้อมูล',
    downloaddata:'ดาวน์โหลดข้อมูล',
    tocart:'ข้อมูลจะถูกเพิ่มลงในตะกร้าสินค้า',
    removecart:'นําออกจากรถเข็น',
    offlinewaring:'ข้อมูลออฟไลน์อยู่',
  },
  userprofilemessage: {

    edit:'แก้ไขข้อมูลผู้ใช้',
    logout:'ลงชื่อออก',
    function:'คุณสมบัติที่มีอยู่',
    download:'ดาวน์โหลดข้อมูล',
    search:'การค้นคืนข้อมูล',
  },
  fpmessage: { // 忘记密码面板

    title:'ลืมรหัสผ่าน',
    mess:'โปรดกรอกแบบฟอร์มนี้เพื่อรับลิงก์ที่อนุญาตให้คุณตั้งรหัสผ่านใหม่',
    username:'ชื่อผู้ใช้',
    usernameempty:'ชื่อผู้ใช้ว่างเปล่า',
    emailvalid:'"รูปแบบอีเมลไม่ถูกต้อง"',
    email:'อีเมล',
    send:'ส่ง',
    errtitle:'ข้อผิดพลาดในการดึงรหัสผ่าน',
    errmess:'ไม่พบผู้ใช้สําหรับชุดชื่อผู้ใช้/อีเมลนี้',
    succtitle:'การกู้คืนรหัสผ่านสําเร็จ',
    succmess:'มีการส่งอีเมลถึงคุณพร้อมคําแนะนําในการรีเซ็ตรหัสผ่านของคุณ',
  },
  rpmessage: { //重置密码面板
    title:'รีเซ็ตรหัสผ่านของคุณ',
    mess:'โปรดกรอกแบบฟอร์มนี้เพื่อรีเซ็ตรหัสผ่านของคุณ',
    passwdrule:'ช่องรหัสผ่านยอมรับเฉพาะตัวอักษรและตัวเลขบวก "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" "_" "-"。 ความยาวขั้นต่ําของช่องรหัสผ่านคือ 8 อักขระ',
    passwd:'รหัสผ่าน',
    emptypasswd:'รหัสผ่านที่ว่างเปล่า',
    passwdvalid:'รหัสผ่านสั้นเกินไป อย่างน้อย 8 ตัวอักษร',
    confirmpasswdvalid:'รหัสผ่านสองรหัสผ่านที่ป้อนไม่ตรงกัน ',
    confirmpasswd:'ยืนยันรหัสผ่าน',
    send:'แก้ไข',
    mbtitle1:'รีเซ็ตรหัสผ่าน',
    mbresult1:'รหัสผ่านของคุณถูกรีเซ็ต',
    mbresult2:'เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน',
    mbtitle2:'การรีเซ็ตรหัสผ่านล้มเหลว',

  },
  registmessage: { //注册面板
    title:'ลงทะเบียนผู้ใช้ใหม่',
    header1:'ผู้ใช้ที่ลงทะเบียนจะได้รับข้อมูลโดยไม่เสียค่าใช้จ่าย',
    notice1:'หลังจากกรอกแบบฟอร์มลงทะเบียนด้านล่างคุณจะได้รับอีเมลพร้อมลิงก์เพื่อยืนยันที่อยู่อีเมลของคุณ หลังจากนี้คุณสามารถเริ่มดาวน์โหลดข้อมูลได้ ช่องชื่อผู้ใช้ยอมรับเฉพาะตัวอักษรและตัวเลขตัวพิมพ์เล็กบวก ".", "-" และ "_" ช่องรหัสผ่านยอมรับเฉพาะตัวอักษรและตัวเลขบวก "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" "_" "-"。 ความยาวขั้นต่ําของช่องรหัสผ่านคือ 8 ตัวอักษร',
    firstname:'นามสกุล',
    lastname:'ชื่อ',
    username:'ชื่อผู้ใช้',
    passwd:'รหัสผ่าน',
    confirmpasswd:'ยืนยันรหัสผ่าน',
    company:'ชื่อบริษัท/องค์กร',
    email:'ที่อยู่อีเมล',
    confirmemail:'ยืนยันที่อยู่อีเมล',
    emailcheck:'ที่อยู่อีเมลมีรูปแบบไม่ถูกต้อง',
    emailmatch:'อีเมลไม่ตรงกัน',
    selectdomain:'เลือกเขตข้อมูล',
    selectusage:'เลือกวัตถุประสงค์',
    selectcountry:'เลือกประเทศ',
    register:'ลงทะเบียน',
    shouquan:'การลงทะเบียนบนเว็บไซต์นี้ถือว่าคุณได้ยอมรับข้อกําหนดและเงื่อนไขการใช้งานข้อมูล GF แล้ว',
  },
  editprofilemessage: { //编辑用户信息面板
    title: 'User {username} profile',
    firstname:'นามสกุล',
    firstnameempty:'ไม่มีการกรอกนามสกุล',
    lastnameempty:'ไม่มีการป้อนชื่อ',
    lastname:'ชื่อ',
    username:'ชื่อผู้ใช้',
    passwd:'รหัสผ่าน',
    confirmpasswd:'ยืนยันรหัสผ่าน',
    company:'ชื่อบริษัท/องค์กร',
    email:'ที่อยู่อีเมล',
    confirmemail:'ยืนยันที่อยู่อีเมล',
    emailcheck:'ที่อยู่อีเมลมีรูปแบบไม่ถูกต้อง',
    emailmatch:'อีเมลไม่ตรงกัน',
    selectdomain:'เลือกเขตข้อมูล',
    selectusage:'เลือกวัตถุประสงค์',
    selectcountry:'เลือกประเทศ',
    passwordalerm1:'กรุณาใส่รหัสผ่าน',
    passwordalerm2:'รหัสผ่านสั้นเกินไปโดยมีอักขระอย่างน้อย 8 ตัว',
    oldpasswd:'ป้อนรหัสผ่านเก่า',
    savemodification:'บันทึกการเปลี่ยนแปลง',
    passwdrule1:'ช่องรหัสผ่านยอมรับเฉพาะตัวอักษรและตัวเลขบวก "!", "@", "#", "$", "%", "^", "&", "*"), "("+" "=" "" "_" "-"。',
    passwdrule2:'ความยาวขั้นต่ําของช่องรหัสผ่านคือ 8 อักขระ',
    changepasswd:'เปลี่ยนรหัสผ่าน',
  },
  loginmessage: { //登陆面板
    title:'กรุณาเข้าสู่ระบบเพื่อเข้าถึงบริการของเรา...',
    username:'ชื่อผู้ใช้',
    passwd:'รหัสผ่าน',
    loginbutton:'ท่าเรือ',
    signup:'ลงทะเบียน',
    fpasswd:'ลืมรหัสผ่านหรือ?',
    passwderr:'กรุณาใส่รหัสผ่าน',
    loginsuccess:'รหัสผ่านสั้นเกินไปโดยมีอักขระอย่างน้อย 8 ตัว',
    logoutsuccess:'"ชื่อผู้ใช้และรหัสผ่านที่คุณป้อนไม่ตรงกันหรือผู้ใช้ไม่ได้เปิดใช้งาน"',
  },
  servicemessage: { //服务状态
    mess:'เข้าสู่ระบบสําเร็จ',
  },

  downloadmessage: { //数据下载面板信息
    title:'ออกจากระบบสําเร็จ',
    downloadmess:'เว็บไซต์ไม่สามารถใช้งานได้ ',
    closemess:'รายละเอียดข้อมูล',
  },
  vdusermessage: { //激活用户
    title:'"ดาวน์โหลดผลิตภัณฑ์"',
    success:'"ปิด" ',
    failed:'เปิดใช้งานบัญชีสําเร็จแล้ว',
  },
  gf1message: {

  },
  gf2message: {
    p1mess:'การเปิดใช้งานบัญชีล้มเหลว',
  },
  gf6message: {},
  reportmessage: {
    title:'สถิติสําหรับบริการศูนย์ข้อมูลทั้งหมดตั้งแต่เริ่มให้บริการ',
    RUsers:'ผู้ใช้ที่ลงทะเบียน',
    download:'การดาวน์โหลดของผู้ใช้',
    Productsnum:'จํานวนผลิตภัณฑ์ที่วางจําหน่าย',
    Availability:'ห้องว่างสําหรับเดือนที่ผ่านมา',
  }
};
